import React from "react";

/**
 * A number is often the right form - no plot needed. Used for the headline
 * counts at the top of the report.
 */
export default function StatTile({ label, value }) {
  return (
    <div className="stat-tile">
      <span className="stat-tile-value">{value}</span>
      <span className="stat-tile-label">{label}</span>
    </div>
  );
}
